import { styled } from "@mui/material";
import { TextFieldSelect } from "shell/OnlineBookingTheme/components";

const Select = styled(TextFieldSelect)(({theme}) => ({
  marginRight: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    marginRight: 0
  }
}));

const Wrapper = styled('div',{target: 'Wrapper'})(({theme}) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    }
}));

const Input = styled('div',{target: 'Input'})(({theme}) => ({

    flexBasis: 'calc(50% - 10px)',
    marginTop: theme.spacing(2),
    alignItems: 'self-start',
    display: 'grid',
    '& div > input': {
      direction: theme.direction === 'rtl' ? 'ltr /* @NoFlip */' : 'initial',
      textAlign: theme.direction === 'rtl' ? 'left': 'initial'
    }

}));

const popperProps = () => {
  return {
    container: document.querySelector('.Main'),
    title: 'Select Date',
    sx: {'&.MuiPopperUnstyled-root': {
        left: '50% !important',
        top: '50% !important',
        transform: 'translate(-50%, -50%) !important',
    }}
  }
}


export { Select, Wrapper, Input, popperProps }